const LOGIN_MESSAGE = 'Per vedere i prezzi e gestire il carrello devi accedere o registrarti.';
const B2B_MESSAGE = 'Per vedere i prezzi e gestire il carrello devi prima completare i dati B2B obbligatori.';
const B2B_DATA_PATH = 'https://shopify.com/74838933573/account/profile?locale=it';

function redirectToLogin() {
  const isAuthenticated = document.documentElement.dataset.customerAuthenticated === 'true';
  window.alert(isAuthenticated ? B2B_MESSAGE : LOGIN_MESSAGE);
  if (isAuthenticated) {
    window.location.href = B2B_DATA_PATH;
    return;
  }
  window.location.href = B2B_DATA_PATH;
}

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const isProductForm = form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    const isCartForm = form.matches('form[action*="/cart"]') || form.querySelector('[name="checkout"]');

    if (!isProductForm && !isCartForm) return;

    event.preventDefault();
    event.stopPropagation();
    redirectToLogin();
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const checkoutTrigger = target?.closest('a[href*="/checkout"], button[name="checkout"], [data-testid*="Checkout"]');
    const cartAction = target?.closest('button[name="add"], add-to-cart-component, quantity-selector-component');

    if (!checkoutTrigger && !cartAction) return;

    event.preventDefault();
    event.stopPropagation();
    redirectToLogin();
  },
  true
);
